import { MainHeaderSharedHelper } from './cc-main-header-shared-helper.js';

class MainHeader extends MainHeaderSharedHelper {
  constructor() {
    super();
    
    this.megaMenus = this.querySelectorAll('mega-menu');
    this.megaMenuParentLinks = this.querySelectorAll('.mega-menu-parent-link');
    this.desktopMediaQuery = window.matchMedia('(min-width: 1025px)');

    this.megaMenus.forEach(menu => {
      if (menu.querySelector('.banner-container').getAttribute('data-type-of-banners') == 'slider') {
        const swiperSliders = slider => {
          return new Swiper(slider, {
            slidesPerView: 'auto',
            speed: 500,
          });
        }

        swiperSliders(menu.querySelector('.swiper'));
      }
    });
  }

  connectedCallback() {
    super.connectedCallback();
    
    // Megamenu initials 
    this.desktopMediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        this.megaMenuPositionUpdate();
      }
    });

    this.megaMenuPositionUpdate();
    this.megaMenuDropdownAccessibility();
  }

  megaMenuPositionUpdate() {
    this.megaMenus.forEach(menu => {
      menu.style.top = `${this.offsetHeight}px`;
    });
  }

  megaMenuDropdownAccessibility() {
    this.megaMenuParentLinks.forEach(button => {
      const parentLi = button.closest('.parent-link');

      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          const expanded = button.getAttribute('aria-expanded') === 'true';

          this.megaMenuParentLinks.forEach(otherBtn => {
            otherBtn.setAttribute('aria-expanded', 'false');
          });

          if (!expanded) {
            button.setAttribute('aria-expanded', 'true');
          }
        }
      });

      parentLi.addEventListener('focusout', (e) => {
        if (!parentLi.contains(e.relatedTarget)) {
          button.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
}

if (!customElements.get('main-header')) {
  customElements.define('main-header', MainHeader);
}
